var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[(_vm.accessBankSlip)?_c('b-embed',{attrs:{"src":_vm.dashboardUrl,"type":"iframe","aspect":"16by9","allowfullscreen":""}}):_c('noPermission',{staticStyle:{"margin-top":"0 !important"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }